module.exports = __webpack_public_path__ + "fa60fe13776d1d0f7d82916bbd4e5b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/computer.png
// module id = 849
// module chunks = 3